import { IConfigMetadata, IConfigStore, IRawConfig } from '../store';
import { ConfigService } from './ConfigService';


export class LocalConfigService<Config = Record<string, unknown>> extends ConfigService {
  private _config: Config;

  constructor(config: Config) {
    super();
    this._config = config;
  }

  async refreshConfig(_name?: string): Promise<ConfigService> {
    return this;
  }

  get configRoot() {
    return this._config;
  }
}

export class LocalConfigStore implements IConfigStore<Record<string, unknown>> {
  rawConfig: IRawConfig<Record<string, unknown>, IConfigMetadata>;

  constructor() {
    this.rawConfig = {
      config: {},
      metadata: {},
    };
  }

  // updateConfig(config: Record<string, unknown>, metadata: IConfigMetadata): void {
  updateConfig(config: any, metadata: any): void {
    this.rawConfig.config = config;
    this.rawConfig.metadata = metadata;
  }

  get config(): any {
    return this.rawConfig.config;
  }

  get metadata(): any {
    return this.rawConfig.metadata;
  }

  clear() {
    this.rawConfig = {};
  }
}